//バリデーション
function check_Validation(){
  const validationForm = document.querySelector('.validationForm');
  if (validationForm) {
    //エラーを表示する span 要素に付与するクラス名
    const errorClassName = 'error';
    const requiredElems = document.querySelectorAll('.required');
    const patternElems = document.querySelectorAll('.pattern');
    const minlengthElems = document.querySelectorAll('.minlength');
    const maxlengthElems = document.querySelectorAll('.maxlength');
    const justlengthElems = document.querySelectorAll('.justlength');
    const equalToElems = document.querySelectorAll('.equal-to');
    const imageFiles = document.querySelectorAll('input[type="file"]');
    const kanaElems = document.querySelectorAll('.katakana');
    let error_flg = true;

    let name_error = 0;
    let kana_error = 0;
    let kanatype_error = 0;
    let zip_error = 0;

    //エラーメッセージを表示する span 要素を生成して親要素に追加する関数
    const createError = (elem, errorMessage) => {
      const errorSpan = document.createElement('span');
      errorSpan.classList.add(errorClassName);
      errorSpan.setAttribute('aria-live', 'polite');
      errorSpan.textContent = errorMessage;
      elem.parentNode.appendChild(errorSpan);
    }

    //form 要素の submit イベントを使った送信時の処理
      const errorElems = document.querySelectorAll('.' + errorClassName);
      errorElems.forEach((elem) => {
        elem.remove();
      });

      //.required を指定した要素を検証
      requiredElems.forEach((elem) => {
        const dataError = elem.getAttribute('data-error-required');
        if (elem.tagName === 'INPUT' && elem.getAttribute('type') === 'radio') {
          const checkedRadio = elem.parentElement.querySelector('input[type="radio"]:checked');
          if (checkedRadio === null) {
            const errorMessage = dataError ? dataError : 'いずれか1つを選択してください';
            createError(elem, errorMessage);
             error_flg = false;
          }
        } else if (elem.tagName === 'INPUT' && elem.getAttribute('type') === 'checkbox') {
          const checkedCheckbox = elem.parentElement.querySelector('input[type="checkbox"]:checked');
          if (checkedCheckbox === null) {
            const errorMessage = dataError ? dataError : '少なくとも1つを選択してください';
            createError(elem, errorMessage);
             error_flg = false;
          }
        } else {
          const elemValue = elem.value.trim();
          if (elemValue.length === 0) {
            if (elem.tagName === 'SELECT') {
              const errorMessage = dataError ? dataError : '選択してください';
              createError(elem, errorMessage);
            } else {
              const errorMessage = dataError ? dataError : '入力は必須です';

              if(dataError == '名前は必須です' || dataError == '名前(カナ)は必須です' ){
                if(dataError == '名前は必須です'){
                  name_error++;
                  if(name_error <= 1){
                    createError(elem, errorMessage);
                  }
                }
                if(dataError == '名前(カナ)は必須です'){
                  kana_error++;
                  if(kana_error <= 1){
                    createError(elem, errorMessage);
                  }
                }
              }else{
                createError(elem, errorMessage);
              }
            }
            error_flg = false;
          }
        }
      });

      //.pattern を指定した要素のパターンを検証
      patternElems.forEach((elem) => {
        let dataPattern = elem.getAttribute('data-pattern');
        let pattern;
        const dataError = elem.getAttribute('data-error-pattern');
        let errorMessage = '';
        if (dataPattern) {
          switch (dataPattern) {
            case 'email':
              pattern = /^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/ui;
              errorMessage = dataError ? dataError : 'メールアドレスには@やドメインが必要です';
              break;
            case 'tel':
              // pattern = /^\(?\d{2,5}\)?[-(\.\s]{0,2}\d{1,4}[-)\.\s]{0,2}\d{3,4}$/;
              pattern = /^0\d{5,13}$/;
              errorMessage = dataError ? dataError : '電話番号の形式が正しくありません。';
              break;
            case 'zip':
              pattern = /^\d{3}-{0,1}\d{4}$/;
              errorMessage = dataError ? dataError : '郵便番号の形式が正しくありません。';
              break;
            case 'date':
              pattern = /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
              errorMessage = dataError ? dataError : '日付の形式が正しくありません。';
              break;
            default:
              pattern = new RegExp(dataPattern);
              errorMessage = dataError ? dataError : '入力された形式が正しくないようです。';
          }
        }
        if (elem.value.trim() !== '') {
          // console.log(pattern.test(elem.value))
          if (!pattern.test(elem.value)) {
            if(dataPattern == '^[0-9]{3}' || dataPattern == '^[0-9]{4}'){
              if(zip_error < 1){
                createError(elem, errorMessage);
                zip_error++;
                // console.log(zip_error)
              }
            }else{
              createError(elem, errorMessage);
              error_flg = false;
            }
          }
        }
      });

      //.justlengthElems を指定した要素のパターンを検証
      justlengthElems.forEach((elem) => {
        let justlength = elem.getAttribute('data-justlength');
        if (justlength && elem.value !== '') {
          if (elem.value.length != justlength) {
            const dataError = elem.getAttribute('data-error-justlength');
            const errorMessage = dataError ? dataError : justlength + '文字で入力ください';
            createError(elem, errorMessage);
            error_flg = false;
          }
        }
      });
      //.minlength を指定した要素のパターンを検証
      minlengthElems.forEach((elem) => {
        let minlength = elem.getAttribute('data-minlength');
        if (minlength && elem.value !== '') {
          if (elem.value.length < minlength) {
            const dataError = elem.getAttribute('data-error-minlength');
            const errorMessage = dataError ? dataError : minlength + '文字以上で入力ください';
            createError(elem, errorMessage);
            error_flg = false;
          }
        }
      });

      //.maxlength を指定した要素のパターンを検証
      maxlengthElems.forEach((elem) => {
        let maxlength = elem.getAttribute('data-maxlength');
        if (maxlength && elem.value !== '') {
          if (elem.value.length > maxlength) {
            const dataError = elem.getAttribute('data-error-maxlength');
            const errorMessage = dataError ? dataError : maxlength + '文字以内で入力ください';
            // createError(elem, errorMessage);
            error_flg = false;

            if(elem.classList.contains('katakana')){
              if(kanatype_error == 0){
                createError(elem, errorMessage);
              }
            }else{
              createError(elem, errorMessage);
            }
          }
        }
      });

      //.equal-to を指定した要素を検証
      equalToElems.forEach((elem) => {
        const equalToId = elem.getAttribute('data-equal-to');
        const equalToElem = document.getElementById(equalToId);
        if (elem.value.trim() !== '' && equalToElem.value.trim() !== '') {
          if (equalToElem.value !== elem.value) {
            const dataError = elem.getAttribute('data-error-equal-to');
            const errorMessage = dataError ? dataError : '入力された値が異なります';
            createError(elem, errorMessage);
            error_flg = false;
          }
        }
      });

      // カタカナ入力チェック
      //.equal-to を指定した要素を検証
      kanaElems.forEach((elem) => {
        str = (elem.value==null) ? "" : elem.value;
        if(elem.value != ''){
          if(str.match(/^[ァ-ヶー　]+$/) == null ){    //"ー"の後ろの文字は全角スペースです。
            if(kanatype_error == 0){
              const errorMessage = '全角カナで入力ください';
              createError(elem, errorMessage);
              kanatype_error++;
            }
          }
        }
      });

      // ファイルアップロード要素を検証
      let totalFileSize = 0;
      let fileUploadErrorFlg = false; // ファイル添付エラーフラグ
      imageFiles.forEach((elem) => {
        if (elem.files[0] != undefined || elem.files[0] != null) {
          totalFileSize += elem.files[0].size;
          if (elem.files[0].size > (1.3 * 1024 * 1024)) {
            const errorMessage = '1MB以内のファイルを添付ください ';
            createError(elem.parentElement, errorMessage);
            fileUploadErrorFlg = true;
          }
        }
      });
      if (totalFileSize > (4 * 1024 * 1024)) {
        createError(document.querySelector('#fileupload3'), '合計3MB以内のファイルを添付ください');
        fileUploadErrorFlg = true;
      }

      if (fileUploadErrorFlg) { 
        error_flg = false;
      }

      //エラーがあればエラーの最初の要素の位置へスクロール
      const errorElem = validationForm.querySelector('.' + errorClassName);
      if (errorElem !== null) {
        const errorParent = errorElem.parentElement;
        if (errorElem) {
          const errorElemOffsetTop = window.pageYOffset + errorParent.getBoundingClientRect().top;
          if (errorElemOffsetTop < 0) {
            return;
          } else {
            setTimeout(function () {
              window.scrollTo({
                top: errorElemOffsetTop - 100,
                behavior: 'smooth'
              });
            }, 100);
          }
        }
      }

    //showCount クラスを指定された要素の集まり
    const showCountElems = document.querySelectorAll('.showCount');
    //data-maxlengthを指定した要素でshowCountクラスが指定されていれば入力文字数を表示
    showCountElems.forEach((elem) => {
      const dataMaxlength = elem.getAttribute('data-maxlength');
      if (dataMaxlength && !isNaN(dataMaxlength)) {
        const countElem = document.createElement('p');
        countElem.classList.add('countSpanWrapper');
        countElem.innerHTML = '<span class="countSpan">0</span>/' + parseInt(dataMaxlength);
        elem.parentNode.appendChild(countElem);
      }
      elem.addEventListener('input', (e) => {
        const countSpan = elem.parentElement.querySelector('.countSpan');
        if (countSpan) {
          const count = e.currentTarget.value.length;
          countSpan.textContent = count;
          if (count > dataMaxlength) {
            countSpan.style.setProperty('color', 'red');
            countSpan.classList.add('overMaxCount');
          } else {
            countSpan.style.removeProperty('color');
            countSpan.classList.remove('overMaxCount');
          }
        }
      });
    });
    return error_flg;
  }
}

jQuery(function ($) {
  // datepicker
  $(function () {
    $(".js-datepicker").datepicker({
      changeYear: true, //年を表示
      yearRange: "-100:+0", //表示年の設定
      changeMonth: true, //月を選択
    });
  });

  // 郵便番号、電話番号を全角、半角変換
  var zen2han = function(str) {
    str = str.replace(/[０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    })
    return str;
  }

  $(".js-changeToHalf").each(function(){
    $(this).on("change", function () {
      var str = $(this).val();
      $(this).val(zen2han(str));
    });
  })


  //プライバシーポリシーの同意
  $(".js-button").on("click", function (event) {
    $(".js-agreement__check").value = true;
    $(".js-button").css("background-color", "#4EC7BC");
    $(".js-confilm").prop("disabled", false);
    $(".js-confilm").css("background-color", "#4EC7BC");

  });

  $('.js-confilm').on('click',function(){
    if (check_Validation() == true) {
      $('.p-form__confirm').html('');
      getFormContent();
    }
  });

  // フォーム入力内容確認ポップアップ
  // ===========================================
  function getFormContent(){
    // フォーム確認画面表示
    let i;
    const formcontent = $('#cform').serializeArray();
    const images = $('#cform input[type="file"]');
    let name, kana,zip;

    formcontent.forEach(item =>{
      const label = $('[name="'+ item.name +'"]').parent().prev().find('.p-form__item-label').text();

      let value = item.value;

      if(item.name == 'customer_sei'){
        name = item.value;
      }
      if(item.name == 'customer_mei'){
        name = name + item.value;
        value = name;
      }
      if(item.name == 'customer_kana_sei'){
        kana = item.value;
      }
      if(item.name == 'customer_kana_mei'){
        kana = kana + item.value;
        value = kana;
      }
      if(item.name == 'zip21'){
        zip = item.value;
      }
      if(item.name == 'zip22'){
        zip = zip + item.value;
        value = zip;
      }
      if(item.name == 'pref21' && item.value != ''){
        value = $('[name="'+ item.name +'"] option[value="'+ item.value +'"]').text();
      }

      if( item.name != 'customer_sei' && item.name != 'customer_kana_sei' && item.name != 'zip21' ){
        $('.p-form__confirm').append(`<dt>${label}</dt><dd>${value}</dd>`);
      }
    });

    // 画像
    let img_confirm = '<dt>添付画像</dt><dd>';
    for(i = 0;i<3;i++){
      if(images[i].files[0] != undefined){
        img_confirm += `<p>${images[i].files[0]['name']}</p>`;
      }
    }
    img_confirm += '</dd>';
    $('.p-form__confirm').append(img_confirm);
    $('#confirmForm').fadeIn();
  }

  // 戻るボタンで入力画面
  // ＝=========================================
  $('.js-back').on('click',function(){
    $('#confirmForm').fadeOut();
  })

  // あとで処理する
  // $('.js-submit').on('click',function(){
  //   //送信（送信完了したらサンクスページへ、完了しなかったら、アラートを表示するなどの処理が必要）
  //   location.href = "/pages/contact-thanks";
  // })


  // フォーム内容送信
  // ＝=========================================

  $('#cform').on('submit',function(e){
    e.preventDefault();
    if(!check_Validation()){
      return;
    }

    let formdata = $(this).serializeArray();
    const images = $('#cform input[type="file"]');
    // console.log(formdata);

      // 入力項目
      let tel =  null;
      let loginId = null;
      let birthday = null;
      let zip =  null;
      let pref =  null;
      let addr1 = null;
      let addr2 =  null;
      let addr3 = null;
      let purchasecode = null;
      let textarea = '';

    for( i = 0; i<formdata.length;  i++){
      // console.log(formdata[i].name)
      if(formdata[i].value != ''){
        switch(formdata[i].name){
          case 'tel':
            tel = formdata[i].value;
            break;
          case 'number':
            loginId = formdata[i].value;
            break;
          case 'calender':
            birthday = formdata[i].value;
            break;
          case 'zip21':
            zip = `${formdata[i].value}-${formdata[i+1].value}`;
            break;
          case 'pref21':
            pref = formdata[i].value;
            break;
          case 'addr1':
            addr1 = formdata[i].value;
            break;
          case 'addr2':
            addr2 = formdata[i].value;
            break;
          case 'addr3':
            addr3 = formdata[i].value;
            break;
          case 'purchaseCode':
            purchasecode = formdata[i].value;
            break;
          case 'textarea':
            textarea = formdata[i].value;
            break;
          default:
        }
      }
    }


    // 入力項目
    // let tel = formdata[7].value != '' ? formdata[7].value.replace("-",""): null;
    // let loginId = formdata[8].value != '' ? formdata[8].value : null;
    // let birthday = formdata[9].value != '' ? formdata[9].value : null;
    // let zip = formdata[10].value != '' ? `${formdata[10].value}-${formdata[11].value}` : null;
    // let pref = formdata[12].value != '' ? formdata[12].value : null;
    // let addr1 = formdata[13].value!= '' ? formdata[13].value: null;
    // let addr2 = formdata[14].value != '' ? formdata[14].value : null;
    // let addr3 = formdata[15].value != '' ? formdata[15].value : null;
    // let purchasecode = formdata[16].value != '' ? formdata[16].value : null;
    // 画像
    let image1,image2,image3;
    let filename = '';
    let extension = '';

    function baseName(str){
        var base = new String(str).substring(str.lastIndexOf('/') + 1);
        if(base.lastIndexOf(".") != -1)
            base = base.substring(0, base.lastIndexOf("."));
            base = base.replace(/\s+/g, '');
            base = base.replace(/\./g, '_');
        return base;
    }

    if(images[0].files.length > 0){
      filename = images[0].files[0].name;
      extension = filename.substring(filename.lastIndexOf('.') + 1);
      image1 = {"name": baseName(filename)+ '.'+ extension, "body": $(images[0]).attr('data-url')}
    }else{
      image1 = [];
    }
    if(images[1].files.length > 0){
      filename = images[1].files[0].name;
      extension = filename.substring(filename.lastIndexOf('.') + 1);
      image2 = {"name":baseName(filename)+ '.'+ extension,  "body": $(images[1]).attr('data-url')}
    }else{
      image2 = [];
    }
    if(images[2].files.length > 0){
      filename = images[2].files[0].name;
      extension = filename.substring(filename.lastIndexOf('.') + 1);
      image3 = {"name":baseName(filename)+ '.'+ extension, "body": $(images[2]).attr('data-url')}
    }else{
      image3 = [];
    }

    // date
    let date = moment().format('YYYY/MM/DD HH:mm:ss');

    // category
    let subcategory = formdata[0].value.split(':')[0];
    subcategory = Number(subcategory.replace(/[^0-9]/g, ''));

    // content
    let content = textarea;


    let mainCategory = window.location.pathname.indexOf('contact-shop') != -1 ? Number(46) : Number(45);

    let subject = mainCategory == 46 ?  formdata[0].value.split(':')[1] : formdata[0].value.split(':')[1];

    let formDataArray

    // console.log(subcategory);.
    if(mainCategory == 46){
      // 店舗
      formDataArray = {
        'mainCategory' : mainCategory,
        'subCategory' : subcategory,
        'lastName': formdata[1].value,
        'firstName': formdata[2].value,
        'lastNameKana': formdata[3].value,
        'firstNameKana': formdata[4].value,
        'email': formdata[5].value,
        'tel': tel,
        'loginId': loginId,
        'birthday':birthday,
        'zipCode': zip,
        'prefecture': pref,
        'address1': addr1,
        'address2': addr2,
        'address3': addr3,
        'useShop': purchasecode,
        'inquirySubject': subject,
        'inquiryContent': content,
        'inquiryDtime': date,
        'inquiryType': null,
        'inputAttachmentFile1':image1,
        'inputAttachmentFile2':image2,
        'inputAttachmentFile3':image3,
      };
    }else{
      //  オンライン
      formDataArray = {
        'mainCategory' : mainCategory,
        'subCategory' : subcategory,
        'lastName': formdata[1].value,
        'firstName': formdata[2].value,
        'lastNameKana': formdata[3].value,
        'firstNameKana': formdata[4].value,
        'email': formdata[5].value,
        'tel': tel,
        'loginId': loginId,
        'birthday':birthday,
        'zipCode': zip,
        'prefecture': pref,
        'address1': addr1,
        'address2': addr2,
        'address3': addr3,
        'purchaseCode': purchasecode,
        'inquirySubject': subject,
        'inquiryContent': content,
        'inquiryDtime': date,
        'inquiryType': null,
        'inputAttachmentFile1':image1,
        'inputAttachmentFile2':image2,
        'inputAttachmentFile3':image3,
      };
    }


    console.log(formDataArray);

    sendForm(formDataArray);
    return false;
  });

  $('input[type="file"]').on('change',function(){
    let elem = this ; //操作された要素を取得
    let base64;
    var reader = new FileReader();
    reader.readAsDataURL(elem.files[0]);
    reader.onload = function (e) {
      base64 = e.target.result;
      $(elem).attr('data-url',base64);
    }
    $(this).parent().parent().find('.file-reset').show();
  })

  $('input[type="file"]').each(function(){
    $(this).parent().parent().append('<button type="button" class="file-reset" style="display: none;">削除</button>');
  });

  $('.file-reset').on('click',function(){
    $(this).parent().find('input').val('');
    $(this).parent().find('input').attr('data-url','');
    $(this).parent().find('span').text('ファイル未選択');
    $(this).hide();
  })

  function sendForm(formData){

    let data = JSON.stringify(formData);

    let posturl = ' https://6hmovno4vtilnknzayxjctbknm0diwpc.lambda-url.ap-northeast-1.on.aws/';

    $.ajax({
      type: 'POST',
      url: posturl,
      crossDomain: true,
      data: data,
      dataType: "text",
    })
    .done(function (data, dataType) {
      // 通信成功時のコールバック処理
      // console.log(JSON.parse(data));

      if(JSON.parse(data).result_code == '200' ){
        location.href = "/pages/contact-thanks";
      }else{
        alert('送信時にエラーが発生しました。再度入力いただき、送信ください。');
      }

    }).fail(function (jqXHR, textStatus, errorThrown) {
      // 通信失敗時のコールバック処理
      // console.log(jqXHR);
      // console.log(jqXHR.responseText);
      // console.log(textStatus);
      // console.log(errorThrown);

      if (jqXHR.status == "413") {
        alert(
          "送信時にエラーが発生しました。再度合計画像サイズをご確認の上、送信ください。"
        );
        return;
      }

      alert('送信時にエラーが発生しました。再度入力いただき、送信ください。');

    }).always(function(data){
    });

  }

});


$(function () {
  const textarea = $("#area1");
  const placeholder = $("#placeholderDiv");
  textarea.on('keyup change', function () {
    // textareaの文字を数える
    let letterLength = textarea.val().length;
    if (letterLength !== 0) {
      placeholder.addClass('none');
    } else {
      placeholder.removeClass('none');
    }
  });

  $('#fileupload1 #file1').on('change', function () {
    var file = $(this).prop('files')[0];
    $(this).closest('#fileupload1').find('#fileName1').text(file.name);
  });

  $('#fileupload2 #file2').on('change', function () {
    var file = $(this).prop('files')[0];
    $(this).closest('#fileupload2').find('#fileName2').text(file.name);
  });

  $('#fileupload3 #file3').on('change', function () {
    var file = $(this).prop('files')[0];
    $(this).closest('#fileupload3').find('#fileName3').text(file.name);
  });

});
